import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-primary text-white py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 flex flex-col md:flex-row items-center justify-between gap-4">
        <Logo light />
        <p className="text-sm text-white/60">
          © {new Date().getFullYear()} Obled Corporation. U.S. Corporation • Global Vision.
        </p>
      </div>
    </footer>
  );
}
